import { FILE_TYPES } from './constants';
import { flatten } from 'lodash';
export var formatFileSize = function formatFileSize(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (bytes === 0) return '0 Bytes';
  var k = 1024;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes = ['b', 'kb', 'mb', 'gb', 'tb', 'pb', 'eb', 'zb', 'yb'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return "".concat(parseFloat((bytes / Math.pow(k, i)).toFixed(dm))).concat(sizes[i]);
};
export var formatFileDateTime = () => new Date().toLocaleTimeString([], {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit'
}).replace(/,/g, '');
export var formatFileName = function formatFileName(fileName) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  var parts = fileName === null || fileName === void 0 ? void 0 : fileName.split('.');
  if (parts) {
    var name = parts.slice(0, -1).join('.');
    var type = parts[parts.length - 1].toLowerCase();
    if (fileName.length > maxLength) {
      var _name;
      name = "".concat((_name = name) === null || _name === void 0 ? void 0 : _name.substring(0, maxLength), "... ");
    }
    return "".concat(name, ".").concat(type);
  }
  return fileName;
};
export var getAllowedFileTypes = flatten(Object.values(FILE_TYPES));